import { render, staticRenderFns } from "./PosiblesClientes.vue?vue&type=template&id=c3ffc582&"
import script from "./PosiblesClientes.vue?vue&type=script&lang=js&"
export * from "./PosiblesClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports